import { render } from "./UserContentTemplate.vue?vue&type=template&id=7ca8b2d2"
import script from "./UserContentTemplate.vue?vue&type=script&lang=js"
export * from "./UserContentTemplate.vue?vue&type=script&lang=js"

import exportComponent from "/app/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__